module.exports = __webpack_public_path__ + "img/icono_mail.59631103.png";